export enum SatisfactionSurveyTestIds {
  MODAL = 'satisfaction-survey-modal',
  SURVEY_LINK = 'satisfaction-survey-link',
  QR_CODE = 'satisfaction-survey-qr-code',
  CONTINUE_BUTTON = 'satisfaction-survey-continue-button',
}
